$(document).ready(function(){

  var header = $('header');
  var headerOffset = header.offset().top;

  $(window).on('scroll', function () {
    if ($(window).scrollTop() > headerOffset) {
      header.addClass('sticky');
    } else {
      header.removeClass('sticky');
    }
  });

  if ($("#Review_Slider").length) {
      $("#Review_Slider").owlCarousel({
        loop: false,
        autoplay: false,
        autoplaySpeed: 1000,
        margin: 40,
        stagePadding: 120,
        nav: true,
        dots: false,
        responsive: {
          0: {
            items: 1,
            stagePadding: 0,
          },
          767: {
            items: 2
          },
          992: {
            items: 2
          }
        }
      });
  }


  $('.play_motions_video').on('click', function(ev) {
    $("#motion_video").fadeIn();
    $("#motion_video").attr("src", "https://www.youtube.com/embed/EngW7tLk6R8?&showinfo=0&rel=0&autoplay=1")
      ev.preventDefault();
    });


  $(".menuic").click(function() {
    $(this).toggleClass("active");
    $("body").toggleClass("active");
  });


  $(".accord_title h3").click(function(){
    if ($(this).parent().hasClass("accordshow")) {
      $(".accord_title").removeClass('accordshow');
      $('.accord_desc').slideUp();
      return false;
    }
    $('.accord_desc').slideUp();
    $(".accord_title").removeClass('accordshow');
    $(this).next().slideDown();
    $(this).parent().addClass('accordshow');
  });

}); //end jquery